import {Route, Routes} from 'react-router-dom'
import {Registration, SocialSignUp} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import GoogleSignIn from './components/GoogleLogin'
import { ActivateUser } from './components/ActivateUser'
import { ErrorsPage } from '../errors/ErrorsPage'
import { PasswordUpdate } from './components/PasswordUpdate'
import { DeleteConfirmation } from './components/ConfirmDeleteBiz'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='google-login' element={<GoogleSignIn />} />
      <Route path='signup' element={<Registration />} />
      <Route path='social-signup' element={<SocialSignUp />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='activate-user' element={<ActivateUser />} />
      <Route path='password-update' element={<PasswordUpdate />} />
      <Route path='confirm-delete' element={<DeleteConfirmation />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
